import * as React from "react";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {a11yProps} from "../../../../tabPanel/functionHelpers";
import {TabPanel} from "../../../../tabPanel/tabPanel";
import {FilterContentByData} from "../filterContent/filterContentByData";
import {setProposalListFilterParams} from "../../../../../business/redux/reducers/filter/actions";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

export const ProposalFilterTabs = () => {

    const {proposalListFilterData} = useSelector(s => s.proposalReducer);

    const {proposalListFilterParams} = useSelector(s => s.filters);

    const branches = (proposalListFilterData?.branches || []).map(el => ({value: el, label: el}))
    const leadOwners = (proposalListFilterData.lead_owners || []).map(el => ({value: el.Owner_id, label: el.Owner_name}))

    const initialTaskListFilter = [
        {
            fieldName: "date",
            displayField: "Date",
            type: "date_range",
        },
        {
            fieldName: "time",
            displayField: "Time",
            type: "time_range",
        },
        {
            fieldName: "leadOwners",
            displayField: "Lead Owners",
            type: "checkbox",
            fields: leadOwners
        },
        {
            fieldName: 'branches',
            displayField: 'Office location',
            type: "checkbox",
            fields: branches
        }
    ]

    const dispatch = useDispatch();

    const [value, setValue] = useState(0);

    const handleChange = (_, newValue) => setValue(newValue);

    const {filters} = useSelector(s => s);

    const {leadFilter, filterParams} = filters;

    return (
        <Box
            className="modal-description"
            sx={{flexGrow: 1, bgcolor: 'background.paper'}}
        >
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Filter Tab"
                className="Filter_Tab"
                indicatorColor="transparent"
                sx={{background: '#EBECF0', p: 2, minWidth: '320px'}}
            >
                {initialTaskListFilter.map((el, idx) => {

                        const data = {...filterParams};

                        if (Boolean(data[el.fieldName]) && Array.isArray(data[el.fieldName])) {
                            data[el.fieldName] = []
                        } else if (Boolean(data[el.fieldName]) && typeof data[el.fieldName] === "string") {
                            data[el.fieldName] = ''
                        } else {
                            delete data[el.fieldName];
                        }

                        delete data[`${el.fieldName}_from`];
                        delete data[`${el.fieldName}_to`];


                        const highlightOffIcon = Boolean(
                            (['checkbox', 'input'].includes(el.type) && leadFilter[el.fieldName]?.length) ||
                            (['date_range', 'number_range'].includes(el.type) && (leadFilter[`${el.fieldName}_from`] || leadFilter[`${el.fieldName}_to`]))
                        )

                        return (
                            <Tab
                                sx={{py: 0, px: 2, mb: 1}}
                                className="filter_tab_btn"
                                label={el.displayField}
                                icon={highlightOffIcon
                                    ? <HighlightOffIcon
                                        color={'error'}
                                        onClick={() => dispatch(setProposalListFilterParams(data))}
                                    />
                                    : <></>}
                                iconPosition={'end'}
                                {...a11yProps(idx)}
                            />
                        );
                    }
                )}
            </Tabs>

            {initialTaskListFilter?.map((el, idx) => (
                <TabPanel
                    key={idx}
                    value={value}
                    index={idx}
                >
                    <FilterContentByData
                        el={el}
                        key={idx}
                        filterParams={proposalListFilterParams}
                        setFilterParams={setProposalListFilterParams}
                    />
                </TabPanel>
            ))}
        </Box>
    );
}
